<template>
  <div class="contractUs">
    <div class="conInside">
      <div class="contentBox">
        <span class="conTitle">Company Overview</span>
      </div>
      <div class="detailBox">
        <!-- <img class="heaImg" src="@/assets/logo.png" alt="" /> -->
        <!-- <div class="hlTop">VOYSTAR</div>
        <div class="hlbtm">VENTURES</div> -->
        <div class="navBox">
          <!-- <div class="about">About Voyage</div> -->
          <p class="text1">
            Voyage Communication Technology Co., Limited (Voyage) is a leading telecom and public sercurity solution provider. Since the establishment of Voyage in Hong Kong in 2022, Voyage has been pursuing the latest technology in communication, AI and public security. 
          </p>
          <p>
            Voyage serves over 30 customers in over 20 countries. Voyage provides original new and used network equipment (Huawei, ZTE, Mobi, Tongyu，H3C, Shoto, etc.), including Core, Transmission, Access, Routers, Switches, Servers, Storage, IP Phones, Firewalls, CPEs, SFPs, Memory & Flash, Hard Disk, Cables, and all kinds of network products and accessories.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.contractUs {
  height: 750px;
  background-color: #f6f6f6;
  // padding: 0 350px;
  .conInside {
    width: 1150px;
    margin: 0 auto;

    .contentBox {
      padding-top: 20px;
      margin-bottom: 40px;
      .conTitle {
        font-size: 28px;
        font-weight: 700;
        border-bottom: 4px solid #0057b8;
        padding-bottom: 10px;
        color: #0057b8;
      }
    }
    .detailBox {
      padding: 20px;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      .heaLeft {
        // text-align: center;
        // margin: 20px auto 50px;
        .heaImg {
          width: 200px;
          height: 200px;
        }
        .hlTop {
          font-size: 60px;
          font-weight: 600;
          border-bottom: 5px solid #000;
        }
        .hlbtm {
          font-size: 50px;
          font-weight: 600;
        }
      }
      .navBox {
        font-size: 22px;
        color: #333333;
        .about {
          font-size: 26px;
          font-weight: 700;
          color: #333333;
        }
        .text1 {
          margin-bottom: 30px;
        }
      }
    }
  }
  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .conInside {
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为1000px 最大为1300px时
  @media screen and (min-width: 1000px) and (max-width: 1300px) {
    .conInside {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为800px 最大为1000px时
  @media screen and (min-width: 800px) and (max-width: 1000px) {
    .conInside {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .conInside {
      width: 90%;
      transition: width 0.3s ease-in-out;
      .contentBox {
        .conTitle {
          font-size: 16px;
          border-bottom: 2px solid #0057b8;
        }
      }
      .detailBox {
        border-radius: 10px;
        .navBox {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
